module.exports = __webpack_public_path__ + "static/media/gcash-image.9888faaf.png";